import { isUndef } from '../shared/utils/validations';

export const getUnread = (rows = []) => {
  if (rows && rows.length > 0) {
    const unread = rows.filter(r => isUndef(r.user_id));
    return unread;
  }
  return [];
};

/*
 *   Get a list of all the journal rows ids that the user has not read so far
 */
export const getUnreadIds = (rows = []) => {
  const ids = [];
  if (rows && rows.length > 0) {
    rows.forEach(r => ids.push(r.id));
  }
  return ids;
};

/*
 *   Convert database date over to pst time zone, default behavior is showing time
 *   if you'd like to show only date then send onlyDate as true
 */
export const convertDateToPST = (strDate, onlyDate = false) => {
  if (strDate) {
    const date = new Date(strDate);
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
    const dateFormatted = onlyDate
      ? utcDate.toLocaleDateString('en-US', {
          timeZone: 'America/Los_Angeles',
        })
      : utcDate.toLocaleString('en-US', {
          timeZone: 'America/Los_Angeles',
        });
    return dateFormatted;
  }
  return strDate;
};

export const convertDateToLocal = strDate => {
  if (strDate) {
    const date = new Date(strDate);
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
    const dateFormatted = utcDate.toLocaleString('en-US');
    return dateFormatted;
  }
  return strDate;
};

/*
 *   Convert notes date to format "MM/DD/YY HH:MM"
 */
export const convertNotesDateToPST = strDate => {
  if (strDate) {
    const date = new Date(strDate);
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes())
    );
    const dateFormatted = utcDate.toLocaleDateString('en-US', {
      timeZone: 'America/Los_Angeles',
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
    return dateFormatted;
  }
  return strDate;
};
